import {
  FiDownload,
  FiPackage,
  FiArchive,
  FiTruck,
  FiUsers,
  FiUserCheck,
  FiShoppingCart,
  FiFileText,
} from "react-icons/fi";

const templates = [
  {
    title: "Products Template",
    description: "Import products with variants, pricing and barcode",
    icon: FiPackage,
    columns: 18,
  },
  {
    title: "Opening Stock Template",
    description: "Import inventory quantities and costs",
    icon: FiArchive,
    columns: 8,
  },
  {
    title: "Suppliers Template",
    description: "Bulk upload supplier database",
    icon: FiTruck,
    columns: 12,
  },
  {
    title: "Customers Template",
    description: "Import customer information",
    icon: FiUsers,
    columns: 10,
  },
  {
    title: "Employees Template",
    description: "Import employee records",
    icon: FiUserCheck,
    columns: 14,
  },
  {
    title: "Sales Orders Template",
    description: "Bulk import sales orders",
    icon: FiShoppingCart,
    columns: 15,
  },
  {
    title: "Purchase Orders Template",
    description: "Bulk import purchase orders",
    icon: FiFileText,
    columns: 16,
  },
  {
    title: "Brands Template",
    description: "Import brand master records",
    icon: FiFileText,
    columns: 4,
  },
  {
    title: "Categories Template",
    description: "Import category structure",
    icon: FiFileText,
    columns: 5,
  },
];

export default function DataTemplatesPage() {
  return (
    <div>
      {/* HEADER */}

      <div className="mb-8">
        <p className="text-sm text-gray-500">
          Tools / Data Templates
        </p>

        <h1 className="text-3xl font-bold mt-1">
          Data Templates
        </h1>

        <p className="text-gray-500 mt-2">
          Download Excel templates for importing ERP data.
        </p>
      </div>

      {/* INFO CARD */}

      <div
        className="
          mb-8
          rounded-3xl
          bg-gradient-to-r
          from-primary-700
          to-primary-600
          text-white
          p-8
        "
      >
        <h2 className="text-2xl font-bold">
          Import Data Faster
        </h2>

        <p className="mt-2 text-primary-100 max-w-3xl">
          Download the required template, fill your data,
          and upload it through Import Center. All templates
          include sample rows and required column formats.
        </p>
      </div>

      {/* STATS */}

      <div className="grid md:grid-cols-4 gap-5 mb-8">
        <StatCard
          title="Templates"
          value="24"
        />

        <StatCard
          title="Downloads"
          value="1,248"
        />

        <StatCard
          title="Imports Supported"
          value="15"
        />

        <StatCard
          title="Success Rate"
          value="99.2%"
        />
      </div>

      {/* TEMPLATE GRID */}

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        {templates.map((template) => {
          const Icon = template.icon;

          return (
            <div
              key={template.title}
              className="
                bg-white
                border
                border-gray-100
                rounded-3xl
                p-6
                hover:shadow-xl
                transition-all
              "
            >
              <div
                className="
                  h-14
                  w-14
                  rounded-2xl
                  bg-primary-50
                  text-primary-700
                  flex
                  items-center
                  justify-center
                "
              >
                <Icon size={24} />
              </div>

              <h3 className="font-bold text-lg mt-5">
                {template.title}
              </h3>

              <p className="text-sm text-gray-500 mt-2">
                {template.description}
              </p>

              <div className="mt-4">
                <span
                  className="
                    px-3
                    py-1
                    rounded-full
                    bg-gray-100
                    text-gray-600
                    text-xs
                    font-medium
                  "
                >
                  {template.columns} Columns
                </span>
              </div>

              <button
                className="
                  mt-6
                  w-full
                  h-11
                  rounded-xl
                  bg-primary-700
                  text-white
                  flex
                  items-center
                  justify-center
                  gap-2
                  font-medium
                "
              >
                <FiDownload />
                Download Template
              </button>
            </div>
          );
        })}
      </div>

      {/* REQUIRED FIELDS */}

      <div className="mt-8 bg-white border border-gray-100 rounded-3xl p-6">
        <h2 className="font-semibold text-lg mb-5">
          Product Template Fields
        </h2>

        <div className="grid md:grid-cols-4 gap-4">
          {[
            "SKU",
            "Product Name",
            "Brand",
            "Category",
            "Sub Category",
            "Color",
            "Size",
            "Barcode",
            "MRP",
            "Cost Price",
            "Selling Price",
            "GST %",
            "Season",
            "Supplier",
            "Unit",
            "Store",
          ].map((field) => (
            <div
              key={field}
              className="
                px-4
                py-3
                rounded-xl
                bg-gray-50
                text-sm
                font-medium
              "
            >
              {field}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function StatCard({ title, value }) {
  return (
    <div className="bg-white border border-gray-100 rounded-3xl p-6">
      <p className="text-sm text-gray-500">
        {title}
      </p>

      <h3 className="text-3xl font-bold mt-2">
        {value}
      </h3>
    </div>
  );
}